import { Crumb } from "@/components/bread-crumbs/Crumb";
import {
  HeadAgreementScreenParamsQuery,
  HeadAgreementScreenParamsQueryVariables,
} from "@/gql/graphql";
import { useQuery } from "@apollo/client";
import { Box } from "@stenajs-webui/core";
import { BreadCrumbs } from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import * as React from "react";
import { routeFactory } from "../../../../../../RouteFactory";
import { headAgreementScreenParamsQuery } from "../copy-or-create-new-ha-to-other-customer/CopyHaToOtherCustomerHeader";
import { useGetCopyFromOtherCustomerBreadCrumbNameQuery } from "./hooks/UseCopyToOtherCustomerBreadCrumbName";
import { PageHeader } from "@/components/page-header/PageHeader";

interface Props {
  customerId: string;
  headAgreementId: string;
}

export const CopyHaFromOtherCustomerHeader: React.FC<Props> = ({
  customerId,
  headAgreementId,
}) => {
  const { data } = useQuery<
    HeadAgreementScreenParamsQuery,
    HeadAgreementScreenParamsQueryVariables
  >(headAgreementScreenParamsQuery, {
    variables: { headAgreementId },
    fetchPolicy: "network-only",
  });

  const headAgreementNumber =
    data?.productPrice.headAgreement.byId?.headAgreementNumber;

  const { breadCrumbName } =
    useGetCopyFromOtherCustomerBreadCrumbNameQuery(customerId);

  return (
    <Box>
      <PageHeader
        title={"Copy from other customer"}
        breadcrumbs={
          <BreadCrumbs>
            <Crumb
              path={routeFactory.productAndPrice.customer.customer({
                customerId,
              })}
              label={breadCrumbName}
            />

            <Crumb
              label={String(headAgreementNumber ?? "")}
              path={routeFactory.productAndPrice.customer.customerHeadAgreement(
                {
                  customerId,
                  headAgreementId: headAgreementId ?? "",
                }
              )}
            />

            <Crumb label={"Copy HA from other customer"} />
          </BreadCrumbs>
        }
      />
    </Box>
  );
};
